import React   from "react";

import { ReactComponent as AudiIcon }   from "../../../assets/images/logo.svg";
import InSearch from "../../InSearch";
import OverlayMobile from "../OverlayMobile";
import ResultsOverlay from "../ResultsOverlay";

const Header = () => {
    return (
        <>
            <header>
                <div className="d-flex">
                    <AudiIcon />
                    <h2 className="ms-3">Audi Collection</h2>
                    <InSearch isMobile={false} />
                </div>
            </header>

            <ResultsOverlay />
            <OverlayMobile headerExtended={false} />
        </>
    );
};

export default Header;
